<template>
  <confirm-modal ref="modal">
    <template slot="body">
      <p>O <strong>nome</strong> da consulta foi alterado. Isso pode ocasionar inconsistência do banco de dados. Deseja realmente fazer a alteração?</p>
    </template>
  </confirm-modal>
</template>

<script>
import ConfirmModal from '@/support/components/modal/ConfirmModal.vue';

export default {
  name: 'ConfirmChangeEndpointNameModal',

  methods: {
    /**
     * Confirm the change endpoint name.
     *
     * @returns {Promise<boolean>}
     */
    confirm() {
      return this.$refs.modal.confirm();
    },
  },

  components: {
    ConfirmModal,
  },
};
</script>

<style lang="scss" scoped>

</style>
